export default __webpack_public_path__ + "static/media/type.af76f140.af76f140.svg";